export default {
  name: 'zh-cn',
  form: {
    search: '查询',
    reset: '重置',
    inputPlaceholder: '请输入',
    selectPlaceholder: '请选择',
    add: '添加',
    previousStep: '上一步',
    nextStep: '下一步',
    minNum: '至少保留',
    minNumUnit: '项',
  },
  tagSelect: {
    all: '全部',
    expand: '展开',
    retract: '收起',
  },
  select: {
    all: '全部',
  },
  table: {
    action: '操作',
    more: '更多',
    addData: '新增数据',
    compact: '紧凑',
    loose: '宽松',
    leftFixed: '左固定',
    unpin: '取消固定',
    rightFixed: '右固定',
    unfixed: '不固定',
    density: '密度',
    columnSetting: '列设置',
    columnDisplay: '列展示',
    deleteTip: '您确定要删除这条数据吗？',
  },
  dialog: {
    got: '知道了',
    tip: '提示',
  },
  crud: {
    add: '新增',
    export: '导出',
    unselect: '取消选择',
    selected: '已选择',
    term: '项',
    multipleDelete: '批量删除',
    deleteTip: '您确定要删除这条数据吗？',
    multipleDeleteTip: '您确定要删除选中的数据吗？',
  },
  watermark: {
    tip: '当前环境不支持Canvas',
  },
  common: {
    save: '保存',
    cancel: '取消',
    edit: '编辑',
    delete: '删除',
    confirm: '确认',
    view: '查看',
    success: '成功',
    operationSuccess: '操作成功',
    default: '默认',
    refresh: '刷新',
    fullScreen: '全屏',
    cancelFullScreen: '取消全屏',
    reset: '重置',
    search: '查询',
    submit: '提交',
  },
}
